module.exports = __webpack_public_path__ + "static/img/header.db71680d.png";